<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/anKang' }">疫情管控</el-breadcrumb-item>
            <el-breadcrumb-item>健康码数据统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main
        style="
          height: 100%;
          padding: 0px !important;
          position: relative;
          width: 100%;
        "
      >
        <el-card style="height: 100% !important" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <p
              :style="{ color: curColor }"
              style="
                border-left: 5px solid #0490f9;
                padding-left: 1vw;
                display: flex;
                align-items: center;
                align-content: center;
              "
            >
              {{ pageTitle }}
            </p>
            <div style="display:flex;align-items:center">
              <!-- <div style="display:flex;align-items:center;margin-right:20px">
                <span style="margin-right:10px">日期:</span>
                <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </div> -->
              <div style="display:flex;align-items:center">
                <el-input
                  v-model="search.name"
                  placeholder="请输入姓名"
                  clearable
                >
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
              </div>
              <el-button type="primary" @click="exportFun" style="margin-left:1vw;">导出表格</el-button>
            </div>
      
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
            >
              <template slot="empty">
                <p>{{ dataText }}</p>
              </template>
              <el-table-column label="序号" width="150" center>
                <template slot-scope="scope">
                  <a style="padding-left: 1vw">{{ scope.row.index }}</a>
                </template>
              </el-table-column>
              <!-- <el-table-column label="项目">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="姓名">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="身份证号">
                <template slot-scope="scope">
                  <span>{{ scope.row.idcard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="体温">
                <template slot-scope="scope">
                  <span v-if="!scope.row.temperature||scope.row.temperature==''"></span>
                  <span v-else-if="scope.row.temperature<37.4" style="color:#67C23A;">{{ scope.row.temperature||0 }}℃</span>
                  <span v-else-if="scope.row.temperature>=37.4" style="color:#F56C6C;">{{ scope.row.temperature||0 }}℃</span>
                  <span v-else>{{ scope.row.temperature }}℃</span>
                </template>
              </el-table-column>
              <el-table-column label="时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.clockTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="进出状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status==0">进闸</span>
                  <span v-else-if="scope.row.status==1">出闸</span>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column label="健康码状态" width="200">
                <template slot-scope="scope">
                  <img :src="scope.row.codeImg" style="height: 6vh" />
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="type == '6' || type == '4' || type =='5'">
                <template slot-scope="scope">
                  <el-button size="mini" type="success" @click="personInfo(scope.$index, scope.row)">更新状态</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import base from '../../../untils/base'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
export default {
  data() {
    return {
      search: {
        //查询
        name: '',
        date: util.myTime.getCurTime(),
        projectId: '',
        healthLevel: '',
      },
      listData: [], //表格数据
      dataText: '数据加载中...',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() > Date.now()
      //   },
      //   shortcuts: [
      //     {
      //       text: '今天',
      //       onClick(picker) {
      //         picker.$emit('pick', new Date())
      //       }
      //     },
      //     {
      //       text: '昨天',
      //       onClick(picker) {
      //         const date = new Date()
      //         date.setTime(date.getTime() - 3600 * 1000 * 24)
      //         picker.$emit('pick', date)
      //       }
      //     },
      //     {
      //       text: '一周前',
      //       onClick(picker) {
      //         const date = new Date()
      //         date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
      //         picker.$emit('pick', date)
      //       }
      //     }
      //   ]
      // },
      // attendType: []
      pageTitle: '',
      projectId: '',
      type: '',
      curColor: '#000000',
    }
  },
  created() {
    if (util.session.get('roleId') == '4') {
      this.projectId = util.session.get('groupId')
    } else {
      this.projectId = util.session.get('proId')
    }
  },
  mounted() {
    if (util.session.get('roleId') == '4') {
      this.projectId = util.session.get('groupId')
    } else {
      this.projectId = util.session.get('proId')
    }
    var params = this.$route.params
    if (params.type == '1') {
      this.pageTitle = '注册人数统计'
      this.curColor = '#597ef0'
    } else if (params.type == '2') {
      this.pageTitle = '核验人数统计'
      this.curColor = '#1d9de4'
    } else if (params.type == '3') {
      this.pageTitle = '正常绿码人数统计'
      this.curColor = '#0ccf93'
    } else if (params.type == '4') {
      this.pageTitle = '异常黄码人数统计'
      this.curColor = '#f8a62a'
    } else if (params.type == '5') {
      this.pageTitle = '异常红码人数统计'
      this.curColor = '#f9693b'
    }else if(params.type=='6'){
      this.pageTitle = '未核验人数统计'
      this.curColor = '#909399'
    }else if(params.type=='7'){
      this.pageTitle = '异常红码记录'
      this.curColor = '#f9693b'
    }
    this.type = params.type
    //this.getDict() //获取考勤
    this.getData()
  },
  methods: {
    //
    // getDict() {
    //   var that = this
    //   myHttp
    //     .getDictByType({
    //       type: 'attend_type'
    //     })
    //     .then(function(resp) {
    //       if (resp.data.code == '200') {
    //         that.attendType = resp.data.data.dictList
    //         that.getData()
    //       } else {
    //         that.$message.error(resp.data.msg)
    //       }
    //     })
    // },
    //获取类型
    // filterSatus(str) {
    //   var list = this.attendType
    //   var result = ''
    //   for (var i = 0; i < list.length; i++) {
    //     if (str == list[i].value) {
    //       result = list[i].label
    //     }
    //   }
    //   return result
    // },
    // 搜索数据
    doFilter() {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    //监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      this.search.healthLevel = this.type
      this.search.projectId = this.projectId
      myHttp.selectAnKangCodeByProjectId(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.PageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              if (list[i].healthLevel == '1') {
                list[i].codeImg = require('../../../assets/image/anKang-gress.png')
              } else if (list[i].healthLevel == '2') {
                list[
                  i
                ].codeImg = require('../../../assets/image/anKang-yellow.png')
              } else if (list[i].healthLevel == '3') {
                list[i].codeImg = require('../../../assets/image/anKang-red.png')
              } else if (
                list[i].healthLevel == '4' ||
                list[i].healthLevel == '0'
              ) {
                list[i].codeImg = require('../../../assets/image/anKang-no.png')
              }
            }
            that.listData = list
            that.totalItems = resp.data.data.PageInfo.total || 0
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function () {}
      )
    },
    exportWorker() {
      // var token = util.session.get('token')
      // window.open(
      //   myHttp.exportAttendList +
      //     '?projectId=' +
      //     this.search.projectId +
      //     '&personName=' +
      //     this.search.personName +
      //     '&date=' +
      //     this.search.date +
      //     '&accessToken=' +
      //     token
      // )
    },
    // watchInput(e) {
    //   this.search.personName = e
    //   this.getData()
    // }
    personInfo(index, row) {
      var that = this
      myHttp.getHealthyByIdCardNo({
        projectId: this.projectId,
        idCard:row.idcardUnhide,
        name: row.name
      }).then(function(resp){
        if(resp.data.code== '0'){
          if(resp.data.result == '4'){
            that.$message.error(resp.data.errMsg)
          }else{
            that.$message.success('更新成功');
            that.getData()
          }
        }else{
          that.$message.error(resp.data.errMsg);
        }
      })
    },
    /**导出列表 */
    exportFun(){
      var token = util.session.get('token')
      window.open(myHttp.exportAnKangCode+'?projectId='+this.projectId+'&healthLevel='+this.type+'&accessToken='+token+'&name='+this.search.name)
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row) {
      var flag = util.common.filterBtnMenu(row)
      return flag
    },
    dofile(){
     this.getData()
    }
  },
}
</script>
<style>
@import '../../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px 1.2vw;
  height: 30px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0 1vw;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-input-group--append .el-input__inner {
  width: 200px;
}
</style>